import React from 'react';
import { useNavigate } from 'react-router-dom';

const VECISurveyCompleted = ({ dashboardUrl = '/app/bumdes/survey-veci' }) => {
  const navigate = useNavigate();

  return (
    <div className='card border-0 shadow-sm rounded-4 p-5 text-center bg-white mt-4'>
      <i className='bi bi-check-circle-fill text-success display-1 mb-4'></i>
      <h2 className='fw-bold'>Survey Selesai</h2>
      <p className='text-muted mb-4'>
        Anda telah menyelesaikan seluruh tahapan Survey Daya Saing BUMDes
        (VECI).
      </p>
      <div>
        <button
          className='btn btn-primary px-4 py-2 rounded-pill shadow-sm fw-bold'
          onClick={() => navigate(dashboardUrl)}
        >
          <i className='bi bi-bar-chart-line-fill me-2'></i> Lihat Dashboard
          VECI
        </button>
      </div>
    </div>
  );
};

export default VECISurveyCompleted;
